module.exports = __webpack_public_path__ + "media/images/export-icon-c13b1ff6fdf8be0d75795daac57c6ec0.svg";